import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactComponent as LogoSvg } from './svgs/logo.svg';
import { ReactComponent as OopsSvg } from './svgs/oops.svg';

export const LogoIcon = (props: SvgIconProps) => {
  return <SvgIcon {...props} component={LogoSvg} inheritViewBox></SvgIcon>;
};

export const OopsIcon = (props: SvgIconProps) => {
  return <SvgIcon {...props} component={OopsSvg} inheritViewBox></SvgIcon>;
};
